import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Row, Container, ListGroup, Button, Modal } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'
import { Helmet } from 'react-helmet'
import { AuthContext } from './AuthContext'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'

// import useFacebookLogin from './useFacebookLogin'

// 第三方授權
// import { LoginSocialFacebook } from 'reactjs-social-login'
// import { LoginSocialGoogle } from 'reactjs-social-login'
import axios from 'axios'

const AuthorizeComponent = () => {
  const { currentUser, setCurrentUser, popUpToast } = useContext(AuthContext)

  // const [FBauthedButton, setFBAuthedButton] = useState(false)
  // const [IGauthedButton, setIGAuthedButton] = useState(false)
  // FB 登入狀態
  const [authFBResponse, setAuthFBResponse] = useState()
  const [isFBInitialized, setIsFBInitialized] = useState(false)

  const [cancelPlatform, setCancelPlatform] = useState('')
  const navigate = useNavigate()

  // const [GGauthedButton, setGGAuthedButton] = useState(false)

  const BaseUrl = 'https://kolstarapi.dsigroup.com.tw/'
  const getChannelList = 'member/v1/GetChannelList'
  const channelAuthUpdate = 'member/v1/ChannelAuthUpdate'
  const getSocialAuthToken = 'member/v1/GetSocialAuthToken'
  const socialAuthTokenUpdate = 'member/v1/SocialAuthTokenUpdate'
  // const bindExternalAccount = 'member/v1/BindExternalAccount'
  const unbindExternalAccount = 'member/v1/UnbindExternalAccount'

  const fbId = process.env.REACT_APP_FB_ID
  const fb_api_version = process.env.REACT_APP_FB_API_VERSION
  const googleId = process.env.REACT_APP_GOOGLE_ID
  const tk = currentUser.tk
  // TODO: 這邊要改
  const redirect_uri = `${window.location.origin}/authorize` //https://kolstar.dsigroup.com.tw
  // const [ytAuth, setYtAuth] = useState(null)

  // TODO: 更新頻道授權列表
  // TODO: 取得&更新社群平台API Token

  // 已授權社群平台
  const [channels, setChannels] = useState({
    facebook_channels: [],
    instagram_channels: [],
    youtube_channels: [],
  })

  const [socialToken, setSocialToken] = useState({
    youtube_token: '',
    facebook_token: '',
    instagram_token: '',
  })

  // 按授權紐 > 有無 token > 取得 Token > 更新 Token > 有授權頻道 > 按鈕變狀態已授權 & 更新授權頻道
  // 已授權 > 按授權紐 > 更新授權頻道 > 按鈕變狀態已授權 & 更新授權頻道
  // 每次拿到新授權就要更新頻道
  // 取消授權也要 update token 跟頻道

  // ================== facebook ==================

  // 載入 Facebook SDK 並完成 init 的動作

  useEffect(() => {
    // SDK 載入完成時會立即呼叫 fbAsyncInit，在這個函式中對 Facebook SDK 進行初始化
    window.fbAsyncInit = function () {
      // 初始化 Facebook SDK
      window.FB.init({
        appId: fbId,
        cookie: true,
        xfbml: true,
        version: fb_api_version,
      })

      console.log('[fbAsyncInit] after window.FB.init')
      setIsFBInitialized(true)
      // 取得使用者登入狀態
      window.FB.getLoginStatus(function (response) {
        console.log('[getLoginStatus]', response)
        setAuthFBResponse(response)
      })
      window.FB.AppEvents.logPageView()
    }
    // 載入 Facebook SDK
    ;(function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
  }, [fbId, fb_api_version])

  const handleFBLogin = () => {
    console.log('isFBInitialized', isFBInitialized)
    // if (!isFBInitialized) {
    //   return
    // }
    // 跳出 Facebook 登入的對話框
    window.FB.login(
      function (response) {
        console.log('handleFBLogin', response)

        /**
         * {
    "authResponse": {
        "userID": "109740484788105",
        "expiresIn": 3813,
        "accessToken": "...",
        "graphDomain": "facebook",
        "data_access_expiration_time": 1700456187
    },
    "status": "connected"
}
         */

        setAuthFBResponse(response)
        if (response.status !== 'unknown') {
          let fb_token = response.authResponse.accessToken
          console.log('tk', tk)

          SocialAuthTokenUpdate('fb', fb_token, tk)

          window.FB.api('/me', function (response) {
            console.log('window.FB.api', response)
            GetSocialAuthToken(tk)
          })

          window.FB.api('/me/accounts', function (response) {
            if (response.data) {
              console.log('/me/accounts', response)
              const facebook_channels = [{ id: '', name: '' }]
              for (let i = 0; i < response.data.length; i++) {
                facebook_channels[i] = {
                  id: response.data[i].id,
                  name: response.data[i].name,
                }
              }
              const newChannels = {
                ...channels,
                facebook_channels: facebook_channels,
              }
              // console.log('newChannels', newChannels)
              setChannels(newChannels)
              ChannelAuthUpdate(newChannels, tk)
            }
          })
        }
      },
      {
        scope: 'pages_show_list read_insights pages_read_engagement',
        auth_type: 'rerequest',
      }
    )
  }

  // instagram
  const handleIGLogin = () => {
    // console.log('isFBInitialized', isFBInitialized)
    // if (!isFBInitialized) {
    //   return
    // }
    // 跳出 Facebook 登入的對話框
    window.FB.login(
      function (response) {
        console.log('handleFBLogin', response)

        setAuthFBResponse(response)
        if (response.status !== 'unknown') {
          let ig_token = response.authResponse.accessToken
          console.log('tk', tk)

          SocialAuthTokenUpdate('ig', ig_token, tk)

          window.FB.api('/me', function (response) {
            console.log('IG.api', response)

            GetSocialAuthToken(tk)
          })

          window.FB.api('/me/accounts', function (response) {
            if (response.data) {
              console.log('/me/accounts', response)
              // const instagram_channels = [{ id: '', name: '' }]
              for (let i = 0; i < response.data.length; i++) {
                window.FB.api(
                  response.data[i].id + '?fields=instagram_business_account',
                  function (response) {
                    // console.log(response);
                    if (response.instagram_business_account) {
                      // console.log(response.instagram_business_account.id);
                      window.FB.api(
                        response.instagram_business_account.id +
                          '?fields=username',
                        function (response) {
                          console.log('instagram_channels', response)
                          const instagram_channels = [
                            { id: response.id, name: response.username },
                          ]
                          const newChannels = {
                            ...channels,
                            instagram_channels: instagram_channels,
                          }
                          console.log('newChannels', newChannels)

                          setChannels(newChannels)
                          ChannelAuthUpdate(newChannels, tk)
                          // if (typeof bind_id != 'undefined') {
                          //   BindExternalAccount('ig', bind_id, bind_token)
                          // }
                        }
                      )
                    }
                  }
                )
              }
            }
          })
        }
      },
      {
        scope: 'instagram_basic pages_show_list instagram_manage_insights',
        auth_type: 'rerequest',
      }
    )
  }
  // ------------------------------------------------
  // ================== google 授權綁定 ==================
  // ------------------------------------------------
  function handleGoogleLogin() {
    oauth2SignIn()
  }

  // ------------------------------------------------
  // 1) OAuth 登入入口：打開 Google OAUTH 2.0 頁面
  // ------------------------------------------------
  function oauth2SignIn() {
    // Google's OAuth 2.0 endpoint for requesting an access token
    const oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth'

    // Create element to open OAuth 2.0 endpoint in new window.
    const form = document.createElement('form')
    form.setAttribute('method', 'GET') // Send as a GET request.
    form.setAttribute('action', oauth2Endpoint)

    // Parameters to pass to OAuth 2.0 endpoint.
    const params = {
      client_id: googleId,
      redirect_uri: redirect_uri,
      scope: 'https://www.googleapis.com/auth/youtube.readonly',
      state: 'youtube',
      include_granted_scopes: 'true',
      response_type: 'token',
      prompt: 'select_account consent',
    }

    // Add form parameters as hidden input values.
    for (const p in params) {
      const input = document.createElement('input')
      input.setAttribute('type', 'hidden')
      input.setAttribute('name', p)
      input.setAttribute('value', params[p])
      form.appendChild(input)
    }

    // Add form to page and submit it to open the OAuth 2.0 endpoint.
    document.body.appendChild(form)
    form.submit()
  }

  // ------------------------------------------------
  // 3) 在頁面載入時檢查 URL，如果帶有 #access_token 就解析
  // ------------------------------------------------
  useEffect(() => {
    const hashString = window.location.hash.substring(1)
    if (!hashString) return

    // 解析 hash
    const parsedParams = {}
    let regex = /([^&=]+)=([^&]*)/g
    let m
    while ((m = regex.exec(hashString))) {
      parsedParams[decodeURIComponent(m[1])] = decodeURIComponent(m[2])
    }

    // 如果發現是 YouTube 且有 access_token，就存起來 & 進行 authenticate
    if (parsedParams['access_token'] && parsedParams['state'] === 'youtube') {
      localStorage.setItem('oauth2-test-params', JSON.stringify(parsedParams))
      // 真正去打 YouTube API、更新後端
      authenticate(parsedParams['access_token'])
    }

    // 解析完就把 hash 清掉
    navigate(window.location.pathname + window.location.search, {
      replace: true,
    })
  }, [])

  // ------------------------------------------------
  // 4) 拿到 access_token 後，真的去 YouTube API 拿頻道 → 更新後端
  // ------------------------------------------------
  async function authenticate(accessToken) {
    try {
      const tk = JSON.parse(Cookies.get('tk')).tk // 從 cookie 拿後端的 tk

      // 先呼叫 YouTube Data API 拿頻道
      const res = await axios.get(
        'https://www.googleapis.com/youtube/v3/channels?part=snippet&mine=true&access_token=' +
          accessToken
      )
      const items = res.data.items
      if (!items || !items.length) {
        // 沒抓到頻道的情況，視需求處理
        console.error('No channels found for this user.')
        return
      }
      const newYoutubeChannel = {
        id: items[0].id,
        name: items[0].snippet.title,
      }

      // 從後端抓取目前的已授權頻道
      const { data: latestChannels } = await axios.get(
        BaseUrl + getChannelList,
        {
          headers: { tk: tk },
        }
      )

      // 合併舊頻道 + 新頻道
      const mergedChannels = {
        facebook_channels: latestChannels.facebook_channels || [],
        instagram_channels: latestChannels.instagram_channels || [],
        youtube_channels: [
          ...(latestChannels.youtube_channels || []),
          newYoutubeChannel,
        ],
      }

      // 只更新 YouTube token
      await SocialAuthTokenUpdate('yt', accessToken, tk)

      // 一次更新所有 Channels
      await ChannelAuthUpdate(mergedChannels, tk)

      // 再把後端「最終結果」拉回到前端 state
      await GetChannelList(tk)

      setCurrentUser(JSON.parse(Cookies.get('tk')))
    } catch (err) {
      console.error('Failed to authenticate YouTube', err)
      // 如果是 401，可再觸發一次 oauth2SignIn() 或提示使用者重試
    }
  }

  // 取得社群平台API Token
  function GetSocialAuthToken(tk) {
    axios
      .get(BaseUrl + getSocialAuthToken, {
        headers: {
          tk: tk,
        },
      })
      .then((res) => {
        console.log('GetSocialAuthToken', res)
        const { youtube_token, facebook_token, instagram_token } = res.data
        setSocialToken({
          youtube_token: youtube_token,
          facebook_token: facebook_token,
          instagram_token: instagram_token,
        })
      })
      .catch((e) => {
        console.log(e)
      })
  }

  // getChannelList
  function GetChannelList(tk) {
    axios
      .get(BaseUrl + getChannelList, {
        headers: {
          'Content-Type': 'text/plain; charset=UTF-8',
          Accept: '*/*',
          tk: tk,
        },
      })
      .then((res) => {
        console.log('GetChannelList', res)
        if (res.data.code === '1000') {
          popUpToast('網頁已逾時，請重新登錄')
          setCurrentUser({
            inc_id: '',
            tk: '',
            kol_id: '',
            kol_name: '',
            lv: 1,
            inc_name: '',
            inc_icon: '',
            isLocked: true,
          })
          Cookies.remove('tk')
          navigate('/')
        } else {
          const { facebook_channels, instagram_channels, youtube_channels } =
            res.data
          setChannels({
            facebook_channels: facebook_channels,
            instagram_channels: instagram_channels,
            youtube_channels: youtube_channels,
          })
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }

  function SocialAuthTokenUpdate(source, token, tk) {
    axios
      .post(
        BaseUrl + socialAuthTokenUpdate,
        {
          source: source,
          token: token,
        },
        {
          headers: {
            'Content-Type': 'text/plain; charset=UTF-8',
            Accept: '*/*',
            tk: tk,
          },
        }
      )
      .then((res) => {
        console.log('socialAuthTokenUpdate', res)
      })
      .catch((e) => {
        console.log(e)
      })
  }
  /**
 * facebook_channels":
  [
      {
        "id":"1234",
        "name":"Test fan group"
      }
  ], 
*/
  function ChannelAuthUpdate(channels, tk) {
    axios
      .post(BaseUrl + channelAuthUpdate, channels, {
        headers: {
          'Content-Type': 'text/plain; charset=UTF-8',
          Accept: '*/*',
          tk: tk,
        },
      })
      .then((res) => {
        console.log('ChannelAuthUpdate', res)
        GetChannelList(tk)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  // If there's an access token, try an API request.
  // Otherwise, start OAuth 2.0 flow.
  function get_yt_token() {
    const params = JSON.parse(localStorage.getItem('oauth2-test-params'))
    if (params && params['access_token']) {
      const xhr = new XMLHttpRequest()
      xhr.open(
        'GET',
        'https://www.googleapis.com/youtube/v3/channels?part=snippet&mine=true&' +
          'access_token=' +
          params['access_token']
      )
      xhr.onreadystatechange = function (e) {
        if (xhr.readyState === 4 && xhr.status === 200) {
          // console.log(xhr.response);
        } else if (xhr.readyState === 4 && xhr.status === 401) {
          // Token invalid, so prompt for user permission.
          oauth2SignIn()
        }
      }
      xhr.send(null)
    } else {
      oauth2SignIn()
    }
    return params['access_token']
  }

  // youtube撤銷憑證
  function revokeAccess(accessToken) {
    axios
      .post('https://oauth2.googleapis.com/revoke', { token: accessToken })
      .then((res) => {
        console.log('revokeAccess youtube', res)
      })
      .catch((e) => console.log(e))
  }

  function UnbindExternalAccount(source) {
    axios
      .post(
        BaseUrl + unbindExternalAccount,
        { source: source },
        {
          headers: {
            'Content-Type': 'text/plain; charset=UTF-8',
            Accept: '*/*',
            tk: currentUser.tk,
          },
        }
      )
      .then((res) => {
        console.log('UnbindExternalAccount', res)
        // 更新按鈕
      })
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    if (currentUser.tk !== '') {
      // console.log('currentUser.tk', currentUser.tk)
      GetChannelList(currentUser.tk)
    }
  }, [currentUser])

  // 取消授權的對話框
  const [modalShow, setModalShow] = useState(false)

  const handleClose = () => setModalShow(false)
  const handleShow = (platform) => {
    setModalShow(true)
    console.log('cancelPlatform', cancelPlatform)
  }

  function cancelAuth() {
    if (cancelPlatform === 'yt') {
      // revokeAccess(get_yt_token())
      UnbindExternalAccount('yt')
      SocialAuthTokenUpdate('yt', '', currentUser.tk)
      const newChannels = {
        ...channels,
        youtube_channels: [],
      }
      ChannelAuthUpdate(newChannels, currentUser.tk)
      navigate(window.location.pathname + window.location.search, {
        replace: true,
      })
    } else if (cancelPlatform === 'fb') {
      window.FB.api('/me/permissions', 'delete', function (response) {
        console.log(response) // true
      })
      if (typeof bind_id !== 'undefined') {
        UnbindExternalAccount('fb')
      }
      const newChannels = {
        ...channels,
        facebook_channels: [],
      }
      ChannelAuthUpdate(newChannels, currentUser.tk)
    } else if (cancelPlatform === 'ig') {
      window.FB.api('/me/permissions', 'delete', function (response) {
        console.log(response) // true
      })
      if (typeof bind_id !== 'undefined') {
        UnbindExternalAccount('ig')
      }
      const newChannels = {
        ...channels,
        instagram_channels: [],
      }
      ChannelAuthUpdate(newChannels, currentUser.tk)
    }
  }

  return (
    <>
      <Helmet>
        <title>社群平台帳號授權 | KOLSTAR</title>
      </Helmet>
      <main className="auth my-4">
        <Container>
          <Row>
            <h2 className="fw-bold">社群平台帳號授權</h2>
            <h5 className="my-2">
              如欲了解更多，請查詢 <Link to="/privacy">隱私權政策</Link> 與{' '}
              <Link to="/terms">使用條款</Link>
            </h5>
            <ListGroup className="my-4">
              <ListGroup.Item className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                <span>已授權的 Facebook 帳號</span>
                <div className="authBtnGroup mr-md-auto d-flex flex-column flex-md-row ">
                  <Button
                    variant={
                      channels.facebook_channels.length > 0
                        ? 'success'
                        : 'primary'
                    }
                    disabled={
                      channels.facebook_channels.length > 0 ? true : false
                    }
                    onClick={() => {
                      // 登入
                      handleFBLogin()
                    }}
                  >
                    {channels.facebook_channels.length > 0
                      ? '已授權'
                      : '點我進行授權'}
                  </Button>
                  <Button
                    disabled={
                      channels.facebook_channels.length > 0 ? false : true
                    }
                    onClick={() => {
                      // 登出
                      handleShow()
                      setCancelPlatform('fb')
                    }}
                    className={
                      channels.facebook_channels.length > 0
                        ? 'btn-danger'
                        : 'btn-secondary'
                    }
                  >
                    取消對 KOLSTAR 的授權
                  </Button>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                <span>已授權的 Instagram 帳號</span>
                <div className="authBtnGroup mr-md-auto d-flex flex-column flex-md-row ">
                  <Button
                    variant={
                      channels.instagram_channels.length > 0
                        ? 'success'
                        : 'primary'
                    }
                    disabled={
                      channels.instagram_channels.length > 0 ? true : false
                    }
                    onClick={() => {
                      // 登入
                      handleIGLogin()
                    }}
                  >
                    {channels.instagram_channels.length > 0
                      ? '已授權'
                      : '點我進行授權'}
                  </Button>
                  <Button
                    disabled={
                      channels.instagram_channels.length > 0 ? false : true
                    }
                    onClick={() => {
                      // 登出
                      handleShow()
                      setCancelPlatform('ig')
                    }}
                    className={
                      channels.instagram_channels.length > 0
                        ? 'btn-danger'
                        : 'btn-secondary'
                    }
                  >
                    取消對 KOLSTAR 的授權
                  </Button>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                <span>已授權的 Google 帳號</span>
                <div className="authBtnGroup mr-md-auto d-flex flex-column flex-md-row ">
                  <Button
                    variant={
                      channels.youtube_channels.length > 0
                        ? 'success'
                        : 'primary'
                    }
                    disabled={
                      channels.youtube_channels.length > 0 ? true : false
                    }
                    onClick={() => handleGoogleLogin()}
                  >
                    {channels.youtube_channels.length > 0
                      ? '已授權'
                      : '點我進行授權'}
                  </Button>
                  <Button
                    disabled={
                      channels.youtube_channels.length > 0 ? false : true
                    }
                    onClick={() => {
                      handleShow()
                      setCancelPlatform('yt')
                    }}
                    className={
                      channels.youtube_channels.length > 0
                        ? 'btn-danger'
                        : 'btn-secondary'
                    }
                  >
                    取消對 KOLSTAR 的授權
                  </Button>
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Row>
        </Container>
        <Container>
          <Row>
            <h2 className="fw-bold">社群平台專頁授權</h2>
            <ListGroup className="my-4 ">
              <ListGroup.Item className="d-flex flex-column flex-md-row align-items-center bg-warning">
                <span className="fw-bold fs-5 my-2">
                  您管理的 Facebook 專頁
                </span>
              </ListGroup.Item>
              {channels.facebook_channels.length > 0 ? (
                channels.facebook_channels.map((v) => {
                  return (
                    <ListGroup.Item
                      action
                      className="d-flex flex-column flex-md-row align-items-center"
                      key={uuidv4()}
                    >
                      <span className="my-2">{v.name}</span>
                    </ListGroup.Item>
                  )
                })
              ) : (
                <ListGroup.Item
                  action
                  className="d-flex flex-column flex-md-row align-items-center"
                >
                  <span className="my-2">目前尚無授權的 Facebook 專頁</span>
                </ListGroup.Item>
              )}
            </ListGroup>
            <ListGroup className="my-4 ">
              <ListGroup.Item className="d-flex flex-column flex-md-row align-items-center bg-warning">
                <span className="fw-bold fs-5 my-2">
                  您管理的 Instagram 專頁
                </span>
              </ListGroup.Item>
              {channels.instagram_channels.length > 0 ? (
                channels.instagram_channels.map((v) => {
                  return (
                    <ListGroup.Item
                      action
                      className="d-flex flex-column flex-md-row align-items-center"
                      key={uuidv4()}
                    >
                      <span className="my-2">{v.name}</span>
                    </ListGroup.Item>
                  )
                })
              ) : (
                <ListGroup.Item
                  action
                  className="d-flex flex-column flex-md-row align-items-center"
                >
                  <span className="my-2">目前尚無授權的 Instagram 專頁</span>
                </ListGroup.Item>
              )}
            </ListGroup>
            <ListGroup className="my-4 ">
              <ListGroup.Item className="d-flex flex-column flex-md-row align-items-center bg-warning">
                <span className="fw-bold fs-5 my-2">您管理的 YouTube 專頁</span>
              </ListGroup.Item>
              {channels.youtube_channels.length > 0 ? (
                channels.youtube_channels.map((v) => {
                  return (
                    <ListGroup.Item
                      action
                      className="d-flex flex-column flex-md-row align-items-center"
                      key={uuidv4()}
                    >
                      <span className="my-2">{v.name}</span>
                    </ListGroup.Item>
                  )
                })
              ) : (
                <ListGroup.Item
                  action
                  className="d-flex flex-column flex-md-row align-items-center"
                >
                  <span className="my-2">目前尚無授權的 YouTube 專頁</span>
                </ListGroup.Item>
              )}
            </ListGroup>
          </Row>
          <Modal show={modalShow} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>取消 KOLSTAR 授權</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              當您選擇「取消對KOLSTAR的授權」時，包含帳號及底下所有綁定的專頁將會全部斷開。確定要取消授權嗎？提醒您，取消後若要使用KOLSTAR的服務，您需要再重新授權。
              <br />
              注意：在取消授權後，系統可能需要一段時間才能撤銷撤銷作業。
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="danger"
                onClick={() => {
                  cancelAuth()
                  handleClose()
                }}
              >
                確定
              </Button>
              <Button variant="secondary" onClick={handleClose}>
                取消
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </main>
    </>
  )
}

export default AuthorizeComponent
